import { getCurrentInstance } from 'vue';
// import { app } from '@/main';
const v = getCurrentInstance();
if (v) {
    const app = v.appContext;
    // 실서버에서만 사용
    if (process.env.VUE_APP_ENV === 'production') {
        app.config.globalProperties.errorHandler = (err, vm, info) => {
            vm.slackWebHook.sendUnhandledError(err, info);
        };
    }
}
